import { Badge } from '@/components/ui/badge';
import { Skeleton } from '@/components/ui/skeleton';
import { TableCell, TableRow } from '@/components/ui/table';
import { useProjectBudget } from '../queries';
import type { Project } from '../types';
import { BudgetBar } from './BudgetBar';

export function ProjectBudgetRow({ project }: { project: Project }) {
  const { data, isPending } = useProjectBudget(project.id);

  if (isPending || !data) {
    return (
      <TableRow>
        <TableCell colSpan={5}>
          <Skeleton className="h-6 w-full" />
        </TableCell>
      </TableRow>
    );
  }

  const budget = Number(data.budget_hours);
  const actual = Number(data.actual_hours);
  const remaining = Number(data.remaining_hours);
  const pct = budget > 0 ? Math.round((actual / budget) * 100) : null;

  return (
    <TableRow>
      <TableCell className="font-medium">{project.name}</TableCell>
      <TableCell className="text-right tabular-nums">{budget || '—'}</TableCell>
      <TableCell className="text-right tabular-nums">{actual.toFixed(2)}</TableCell>
      <TableCell className="text-right tabular-nums">
        <span className={remaining < 0 ? 'text-destructive' : ''}>
          {budget ? remaining.toFixed(2) : '—'}
        </span>
      </TableCell>
      <TableCell>
        {budget ? (
          <div className="flex items-center gap-2">
            <BudgetBar actual={actual} budget={budget} />
            <span className="text-muted-foreground w-12 text-right text-xs tabular-nums">{pct}%</span>
            {data.over_budget ? (
              <Badge variant="destructive" className="shrink-0">
                Over
              </Badge>
            ) : null}
          </div>
        ) : (
          <span className="text-muted-foreground text-sm">No budget set</span>
        )}
      </TableCell>
    </TableRow>
  );
}
